import { useCallback, useRef } from "react";

const TEEN_SOUND_SRC = "/sounds/teen-message.mp3";
const OPS_SOUND_SRC = "/sounds/ops-message.mp3";
const WARNING_SOUND_SRC = "/notification.mp3";

export function useMessageNotificationSound() {
  const teenSound = useRef<HTMLAudioElement>(new Audio(TEEN_SOUND_SRC));
  const opsSound = useRef<HTMLAudioElement>(new Audio(OPS_SOUND_SRC));
  const warningSound = useRef<HTMLAudioElement>(new Audio(WARNING_SOUND_SRC));

  const playSound = useCallback((audio: HTMLAudioElement) => {
    audio.currentTime = 0;
    audio.play().catch((error: Error) => {
      if (error.name === "NotAllowedError") {
        console.log("Autoplay prevented - waiting for user interaction");
      } else {
        console.error("Error playing message notification:", error);
      }
    });
  }, []);

  const playTeenMessageSound = useCallback(
    () => playSound(teenSound.current),
    [playSound],
  );

  const playOpsMessageSound = useCallback(
    () => playSound(opsSound.current),
    [playSound],
  );

  const playWarningSound = useCallback(
    () => playSound(warningSound.current),
    [playSound],
  );

  return {
    playTeenMessageSound,
    playOpsMessageSound,
    playWarningSound,
  };
}
